type PersistentFormLifecycle = {
  clearTransient?: () => void;
  invalidate: () => void;
  release: () => void;
  resetAltcha: () => void;
  resetAct?: () => void;
  resetUi: () => void;
};

export function deactivatePersistentForm(
  lifecycle: PersistentFormLifecycle,
): void {
  lifecycle.invalidate();
  lifecycle.resetAltcha();
  lifecycle.release();
  lifecycle.clearTransient?.();
  lifecycle.resetUi();
}

export function switchReplyDraft(
  threadId: string,
  readDraft: (threadId: string) => string,
  applyDraft: (formData: { comment: string }) => void,
  lifecycle: PersistentFormLifecycle,
): void {
  lifecycle.invalidate();
  lifecycle.release();
  lifecycle.resetAltcha();
  lifecycle.clearTransient?.();
  lifecycle.resetUi();
  lifecycle.resetAct?.();
  applyDraft({ comment: readDraft(threadId) });
}

export function isModalFormActive(isOpen: boolean): boolean {
  return isOpen;
}

export function isPanelFormActive(collapsed: boolean): boolean {
  return !collapsed;
}
